<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="title">
            <el-form class="form-inlines" >
                <el-form-item>
                    <el-button size="small" @click="addxm" type="primary">添加项目</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-row :gutter="20">
                <!-- 左侧树模型 -->
                <el-col :span="6">
                    <el-card shadow="never" :loading="loading">
                        <div :style="constyled">
                            <el-tree :data="left_data" :props="defaultProps" node-key="id" @node-click="handleNodeClick"
                                ref="tree" :default-checked-keys="idArr">
                                <span class="custom-tree-node" slot-scope="{ node, data }">
                                    <span @dblclick="dbClick(node,data)">{{ node.label }}</span>
                                </span>
                            </el-tree>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="18">
                    <el-card shadow="never" :style="constyle">
                        <el-table :data="tableData1" border style="width: 100%" v-show="typeShow==false">
                            <el-table-column prop="id" label="编号"> </el-table-column>
                            <el-table-column prop="system" label="项目名称"></el-table-column>
                            <el-table-column prop="system_value" label="项目值"></el-table-column>
                            <el-table-column prop="sort" label="排序"></el-table-column>
                            <el-table-column label="操作" width='150'>
                                <template slot-scope="scope">
                                    <el-button size="mini" type="primary" @click="Editxm( scope.row)">
                                        编辑</el-button>
                                    <el-button size="mini" type="danger" @click="Deletexm( scope.row)">
                                        删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div v-show="typeShow==true">
                            <div class="ibox-content" style="text-align: right;margin-bottom:5px">
                                <el-button size="small" @click="addnr" type="primary">新增</el-button>
                            </div>
                            <div class="ibox-content">
                                <el-table :data="tableData2.slice((currentPage-1)*pagesize,currentPage*pagesize)" border
                                    style="width: 100%" v-loading="loadings" height="450">
                                    <el-table-column prop="id" label="编号"> </el-table-column>
                                    <el-table-column prop="content_name" label="内容"></el-table-column>
                                    <el-table-column prop="content_value" label="内容值"></el-table-column>
                                    <el-table-column prop="sort" label="排序"></el-table-column>
                                    <el-table-column label="操作" width='150'>
                                        <template slot-scope="scope">
                                            <el-button size="mini" type="primary" @click="handleEdit(scope.row)">
                                                编辑</el-button>
                                            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">
                                                删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div class="block page_r">
                                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                        :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pagesize"
                                        layout="total, sizes, prev, pager, next, jumper" :total="tableData2.length">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <div>
            <!-- 项目 -->
            <el-dialog title="项目添加" :visible.sync="dialog"  class="dialogs">
                <el-divider></el-divider>
                <div class="dialog-ibox-content">
                    <el-form :model="xmForm" :rules="rule" ref="xmForm" label-width="100px">
                        <el-form-item label="项目名称" prop="title">
                            <el-input v-model="xmForm.title" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="项目值" prop="value">
                            <el-input v-model="xmForm.value" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="排序">
                            <el-input v-model="xmForm.sort" size="small" type="number"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <el-divider></el-divider>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialog=false" size="small">取 消</el-button>
                    <el-button type="primary" @click="subxm('xmForm')" size="small">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog title="项目修改" :visible.sync="dialogxm"  class="dialogs">
                <el-divider></el-divider>
                <div class="dialog-ibox-content">
                    <el-tabs type="card" v-model="activeName">
                        <el-tab-pane label="项目编辑">
                            <el-form :model="xmForms" :rules="rulexm" ref="xmForms" label-width="100px">
                                <el-form-item label="项目名称" prop="title">
                                    <el-input v-model="xmForms.title" size="small"></el-input>
                                </el-form-item>
                                <el-form-item label="项目值" prop="value">
                                    <el-input v-model="xmForms.value" size="small"></el-input>
                                </el-form-item>
                                <el-form-item label="排序">
                                    <el-input v-model="xmForms.sort" size="small" type="number"></el-input>
                                </el-form-item>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane label="添加类型">
                            <el-form :model="zlForm" :rules="rulezl" ref="zlForm" label-width="100px">
                                <el-form-item label="项目名称">
                                    <span>{{xmForms.title}}</span>
                                </el-form-item>
                                <el-form-item label="类型名称" prop="title">
                                    <el-input v-model="zlForm.title" size="small"></el-input>
                                </el-form-item>
                                <el-form-item label="类型值" prop="value">
                                    <el-input v-model="zlForm.value" size="small"></el-input>
                                </el-form-item>
                                <el-form-item label="排序">
                                    <el-input v-model="zlForm.sort" size="small" type="number"></el-input>
                                </el-form-item>
                            </el-form>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <el-divider></el-divider>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="delxm" size="small" type="danger" v-show='activeName==0' style="float: left;">
                        删除项目</el-button>
                    <el-button @click="dialogxm=false" size="small">取 消</el-button>
                    <el-button type="primary" @click="subxms('xmForms')" size="small" v-show='activeName==0'>提 交
                    </el-button>
                    <el-button type="primary" @click="subzl('zlForm')" size="small" v-show='activeName==1'>确 定
                    </el-button>
                </span>
                <div style="clear: both;"></div>
            </el-dialog>
            <!-- 类型 -->
            <el-dialog title="修改类型" :visible.sync="dialoglx"  class="dialogs">
                <el-divider></el-divider>
                <div class="dialog-ibox-content">
                    <el-form :model="zlForms" :rules="rulezls" ref="zlForms" label-width="100px">
                        <el-form-item label="项目名称">
                            <span>{{parentname}}</span>
                        </el-form-item>
                        <el-form-item label="类型名称" prop="title">
                            <el-input v-model="zlForms.title" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="类型值" prop="value">
                            <el-input v-model="zlForms.value" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="排序">
                            <el-input v-model="zlForms.sort" size="small" type="number"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <el-divider></el-divider>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dellx" size="small" type="danger" style="float: left;">删除类型</el-button>
                    <el-button @click="dialoglx=false" size="small">取 消</el-button>
                    <el-button type="primary" @click="sublxed('zlForms')" size="small">确 定</el-button>
                </span>
                <div style="clear: both;"></div>
            </el-dialog>
            <!--  三层-->
            <el-dialog title="新增内容" :visible.sync="dialogsd" class="dialogs">
                <el-divider></el-divider>
                <div class="dialog-ibox-content">
                    <el-form :model="nrForms" :rules="rulesd" ref="nrForms" label-width="100px">
                        <el-form-item label="项目名称">
                            <span> {{parentname}}</span>
                        </el-form-item>
                        <el-form-item label="类型名称">
                            <span> {{childname}}</span>
                        </el-form-item>
                        <el-form-item label="内容名称" prop="title">
                            <el-input v-model="nrForms.title" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="内容值" prop="value">
                            <el-input v-model="nrForms.value" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="排序">
                            <el-input v-model="nrForms.sort" size="small" type="number"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <el-divider></el-divider>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogsd=false" size="small">取 消</el-button>
                    <el-button type="primary" @click="subnred('nrForms')" size="small">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog title="编辑数据" :visible.sync="dialogs"  class="dialogs">
                <el-divider></el-divider>
                <div class="dialog-ibox-content">
                    <el-form :model="nrForm" :rules="rules" ref="nrForm" label-width="100px">
                        <el-form-item label="项目名称">
                            <span> {{parentname}}</span>
                        </el-form-item>
                        <el-form-item label="类型名称">
                            <span> {{childname}}</span>
                        </el-form-item>
                        <el-form-item label="内容名称" prop="title">
                            <el-input v-model="nrForm.title" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="内容值" prop="value">
                            <el-input v-model="nrForm.value" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="排序">
                            <el-input v-model="nrForm.sort" size="small" type="number"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <el-divider></el-divider>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogs=false" size="small">取 消</el-button>
                    <el-button type="primary" @click="subnr('nrForm')" size="small">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
    export default {
        name: "index",
        data() {
            return {
                idArr: [],
                loading: false,
                loadings: false,
                left_data: [],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                constyled: {
                    height: null,
                    'overflow': 'auto'
                },
                constyle: {
                    height: null,
                },
                dialog: false,
                xmForm: {
                    title: '',
                    value: '',
                    sort: 50
                },
                hosd_arr: [],
                rule: {
                    title: [{
                        required: true,
                        message: '请填写项目名称',
                        trigger: 'blur'
                    }],
                    value: [{
                        required: true,
                        message: '请填写项目值',
                        trigger: 'blur'
                    }]
                },
                dialogxm: false,
                xmForms: {
                    title: '',
                    value: '',
                    sort: 50
                },
                rulexm: {
                    title: [{
                        required: true,
                        message: '请填写项目名称',
                        trigger: 'blur'
                    }],
                    value: [{
                        required: true,
                        message: '请填写项目值',
                        trigger: 'blur'
                    }]
                },
                xmid: '',
                tableData1: [],
                tableData2: [],
                typeShow: false,
                dialogs: false,
                nrForm: {
                    title: '',
                    value: '',
                    sort: 50
                },
                rules: {
                    title: [{
                        required: true,
                        message: '请填写内容',
                        trigger: 'blur'
                    }],
                    value: [{
                        required: true,
                        message: '请填写内容值',
                        trigger: 'blur'
                    }]
                },
                sys_id: '',
                type_id: '',
                hospitaled: '',
                eid: '',
                objrow: {},
                dialogsd: false,
                nrForms: {
                    title: '',
                    value: '',
                    sort: 50
                },
                rulesd: {
                    title: [{
                        required: true,
                        message: '请填写内容',
                        trigger: 'blur'
                    }],
                    value: [{
                        required: true,
                        message: '请填写内容值',
                        trigger: 'blur'
                    }]
                },
                activeName: '0',
                zlForm: {
                    title: '',
                    value: '',
                    sort: 50
                },
                rulezl: {
                    title: [{
                        required: true,
                        message: '请填写类型名称',
                        trigger: 'blur'
                    }],
                    value: [{
                        required: true,
                        message: '请填写类型值',
                        trigger: 'blur'
                    }]
                },
                dialoglx: false,
                zlForms: {
                    title: '',
                    value: '',
                    sort: 50
                },
                rulezls: {
                    title: [{
                        required: true,
                        message: '请填写类型名称',
                        trigger: 'blur'
                    }],
                    value: [{
                        required: true,
                        message: '请填写类型值',
                        trigger: 'blur'
                    }]
                },
                lx_id: '',
                parentrow: {},
                parentname: '',
                childname: '',
                pagesize: 10,
                currentPage: 1,
                count: 0,
            }
        },
        computed: {
		    ...mapState({
				user:state=>state.user.user,
			})
		},
        mounted() {
            let that = this;
            that.getHeight()
            that.gethosed()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                // 左侧的树形
                var title = that.$refs.title.offsetHeight
                that.constyled.height = window.innerHeight - title - 200 + 'px'
                // 右侧  
                that.constyle.height = window.innerHeight - title -160 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.constyled.height = window.innerHeight - title - 200 + 'px'
                    that.constyle.height = window.innerHeight - title - 160 + 'px'
                }
            },
            // 左侧树形
            gethosed() {
                let that = this
                that.loading = true
                this.axios
                    .post("/admin/DictionaryModel/SystemShowlist", {}, {
                        token: true,
                    })
                    .then(response => {
                        that.loading = false
                        that.left_data = response.data.data.list
                        that.getxminfo()
                    })
                    .catch(error => {})
            },
            // 开始获取右侧项目
            getxminfo() {
                let that = this
                this.axios
                    .post("/admin/DictionaryModel/RightList", {
                        source: "system",
                    }, {
                        token: true,
                    })
                    .then(response => {
                        that.tableData1 = response.data.data
                    })
                    .catch(error => {})
            },
            // 项目添加
            addxm() {
                let that = this
                that.dialog = true
                that.xmForm.title = ''
            },
            // 项目的添加提交
            subxm(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        that.axios
                            .post("/admin/DictionaryModel/SystemAdd", {
                                source: 'system',
                                system: that.xmForm.title,
                                system_value: that.xmForm.value,
                                author: that.user.id,
                                sort: that.xmForm.sort,
                            }, {
                                token: true,
                            })
                            .then(response => {
                                if (response.data.code == "200") {
                                    that.gethosed()
                                    that.xmForm.title = ''
                                    that.xmForm.value = ''
                                    that.$message({
                                        showClose: true,
                                        type: 'success',
                                        message: response.data.msg
                                    });
                                } else {
                                    that.$message({
                                        showClose: true,
                                        type: 'error',
                                        message: response.data.msg
                                    });
                                }
                            })
                            .catch(error => {})
                    } else {}
                });
            },
            //树形点击
            handleNodeClick(data,node) {
                let that = this
                that.parentname = data.system_name
                that.childname = data.name
                that.objrow = data
                that.currentPage = 1
                if (data.level == 'content') {
                    that.typeShow = true
                    that.loadings = true
                    that.axios
                        .post("/admin/DictionaryModel/RightList", {
                            source: data.level,
                            sys_id: data.sys_id,
                            type_id: data.id
                        }, {
                            token: true,
                        })
                        .then(response => {
                            that.loadings = false
                            that.tableData2 = response.data.data
                        })
                        .catch(error => {})
                } else {
                    that.typeShow = false
                }
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.currentPage = 1
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
            },
            // 编辑内容
            handleEdit(row) {
                let that = this
                that.dialogs = true
                that.eid = row.id
                that.axios
                    .post("/admin/DictionaryModelTypeContent/ContentEditInfo", {
                        id: that.eid
                    }, {
                        token: true,
                    })
                    .then(response => {
                        var data= response.data.data
                        that.nrForm.sort =data.sort
                        that.nrForm.title =data.content_name
                        that.nrForm.value =data.content_value
                        that.sys_id = data.sys_id
                        that.type_id =data.type_id
                        that.parentname =data.system
                        that.childname =data.type_name
                    })
                    .catch(error => {})
            },
            // 内容的提交
            subnr(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.axios
                            .post("/admin/DictionaryModelTypeContent/ContentEdit", {
                                sys_id: that.sys_id,
                                type_id: that.type_id,
                                content_name: that.nrForm.title,
                                content_value: that.nrForm.value,
                                id: that.eid,
                                author: that.user.id,
                                sort: that.nrForm.sort,
                            }, {
                                token: true,
                            })
                            .then(response => {
                                if (response.data.code == "200") {
                                    that.dialogs = false
                                    that.handleNodeClick(that.objrow)
                                    that.$message({
                                        showClose: true,
                                        type: 'success',
                                        message: response.data.msg
                                    });
                                } else {
                                    that.$message({
                                        showClose: true,
                                        type: 'error',
                                        message: response.data.msg
                                    });
                                }
                            })
                            .catch(error => {})
                    } else {}
                });
            },
            //内容删除
            handleDelete(row) {
                let that = this
                that.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios
                        .post("/admin/DictionaryModelTypeContent/ContentDel", {
                            id: row.id,
                        }, {
                            token: true,
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                that.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.handleNodeClick(that.objrow)
                            } else {
                                alert(response.data.msg)
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            // 新增
            addnr() {
                let that = this
                that.nrForms.title = ''
                that.nrForms.value = ''
                that.dialogsd = true
            },
            // 新增内容的提交
            subnred(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.axios
                            .post("/admin/DictionaryModelTypeContent/ContentAdd", {
                                id:'',
                                sys_id: that.objrow.sys_id,
                                type_id: that.objrow.id,
                                content_name: that.nrForms.title,
                                content_value: that.nrForms.value,
                                sort: that.nrForms.sort,
                                author: that.user.id,
                            }, {
                                token: true,
                            })
                            .then(response => {
                                if (response.data.code == "200") {
                                    that.nrForms.title = ''
                                    that.nrForms.value = ''
                                    that.handleNodeClick(that.objrow)
                                    that.$message({
                                        showClose: true,
                                        type: 'success',
                                        message: response.data.msg
                                    });
                                } else {
                                    that.$message({
                                        showClose: true,
                                        type: 'error',
                                        message: response.data.msg
                                    });
                                }
                            })
                            .catch(error => {})
                    } else {}
                });
            },
            // 编辑项目
            Editxm(row) {
                let that = this
                that.dialogxm = true
                that.zlForm.title = ''
                that.zlForm.value = ''
                that.xmid = row.id
                this.axios
                    .post("/admin/DictionaryModel/SystemEditInfo", {
                        id: row.id
                    }, {
                        token: true,
                    })
                    .then(response => {
                        var data = response.data.data
                        that.xmForms.title = data.system
                        that.xmForms.value = data.system_value
                        that.xmForms.sort = data.sort
                    })
                    .catch(error => {})
            },
            // 编辑的提交
            subxms(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.axios
                            .post("/admin/DictionaryModel/SystemEdit", {
                                system: that.xmForms.title,
                                system_value: that.xmForms.value,
                                sort: that.xmForms.sort,
                                id: that.xmid,
                                author: that.user.id,
                            }, {
                                token: true,
                            })
                            .then(response => {
                                if (response.data.code == '200') {
                                    that.$message({
                                        type: 'success',
                                        message: '编辑成功!'
                                    });
                                    that.dialogxm = false
                                    that.gethosed()
                                } else {
                                    that.$message({
                                        showClose: true,
                                        type: 'error',
                                        message: response.data.msg
                                    });
                                }
                            })
                            .catch(error => {})
                    } else {}
                });
            },
            // 项目的删除
            Deletexm(row) {
                let that = this
                that.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios
                        .post("/admin/DictionaryModel/SystemDel", {
                            id: row.id,
                        }, {
                            token: true,
                        })
                        .then(response => {
                            if (response.data.code == "200") {
                                that.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.gethosed()
                            } else {
                                alert(response.data.msg)
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            // 双击
            dbClick(node, data) {
                let that = this
                that.objrow = data
                that.activeName = '0'
                if (data.level == 'type') {
                    // 第一层数据
                    that.Editxm(data)
                } else if (data.level == 'content') {
                    // 第二层
                    that.parentname = node.parent.data.name
                    that.lx_id = data.id
                    that.dialoglx = true
                    this.axios
                        .post("/admin/DictionaryModelType/TypeEditInfo", {
                            id: data.id
                        }, {
                            token: true,
                        })
                        .then(response => {
                            var data = response.data.type_info
                            that.zlForms.title = data.type_name
                            that.zlForms.value = data.type_value
                            that.zlForms.sort = data.sort
                        })
                        .catch(error => {})
                }
            },
            // 子类添加接口
            subzl(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.axios
                            .post("/admin/DictionaryModelType/TypeAdd", {
                                id:'',
                                author: that.user.id,
                                type_name: that.zlForm.title,
                                type_value: that.zlForm.value,
                                sort: that.zlForm.sort,
                                sys_id: that.xmid,
                            }, {
                                token: true,
                            })
                            .then(response => {
                                if (response.data.code == "200") {
                                    that.gethosed()
                                    that.zlForm.title = ''
                                    that.zlForm.value = ''
                                    that.$message({
                                        type: 'success',
                                        message: '操作成功!'
                                    });
                                } else {
                                    alert(response.data.msg)
                                }
                            })
                            .catch(error => {})
                    } else {}
                });
            },
            // 子类的编辑提交
            sublxed(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.axios
                            .post("/admin/DictionaryModelType/TypeEdit", {
                                sys_id: that.objrow.sys_id,
                                type_name: that.zlForms.title,
                                type_value: that.zlForms.value,
                                sort: that.zlForms.sort,
                                id: that.lx_id,
                                author: that.user.id,
                            }, {
                                token: true,
                            })
                            .then(response => {
                                if (response.data.code == "200") {
                                    that.dialoglx = false
                                    that.$message({
                                        type: 'success',
                                        message: '操作成功!'
                                    });
                                    that.gethosed()
                                } else {
                                    alert(response.data.msg)
                                }
                            })
                            .catch(error => {})
                    } else {}
                });
            },
            delxm() {
                let that = this
                that.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios
                        .post("/admin/DictionaryModel/SystemDel", {
                            id: that.objrow.id,
                        }, {
                            token: true,
                        })
                        .then(response => {
                            if (response.data.code == "200") {
                                that.dialogxm = false
                                that.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.gethosed()
                            } else {
                                alert(response.data.msg)
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            // 类型的删除
            dellx() {
                let that = this
                that.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios
                        .post("/admin/DictionaryModelType/TypeDel", {
                            id: that.objrow.id,
                        }, {
                            token: true,
                        })
                        .then(response => {
                            if (response.data.code == "200") {
                                that.dialoglx = false
                                that.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.gethosed()
                            } else {
                                alert(response.data.msg)
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
        },
        watch: {},
    }
</script>
<style scoped>
    .menu_item {
        line-height: 20px;
        text-align: center;
        margin-top: 10px;
    }

    .menu {
        height: 100px;
        width: 80px;
        position: absolute;
        border-radius: 10px;
        border: 1px solid #999999;
        background-color: #f4f4f4;
    }
    .form-inlines .el-form-item {
        text-align: end;
    }

</style>